<style>
    .vs-card--content {
        margin-bottom: 0;
    }

    .vs-con-textarea {
        margin-bottom: 0;
    }

    .vs-table--tbody-table .tr-values td {
        padding: 3px;
    }
</style>

<template>
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Add New Outbound</h4>
                    </div>
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm" :disabled="data.outbound_delivery_details.length > 0 ? false : true">Save</vs-button>
                </div>
                <div class="vx-row mt-6">
                    <div class="vx-col lg:w-1/5 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Outbound Reference*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.outbound_delivery.outbound_reference" />
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Request Delivery Date*
                            </div>
                            <div class="vx-col w-2/3">
                                <flat-pickr class="w-full" v-model="data.outbound_delivery.req_del_date" />
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Client ID*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.outbound_delivery.client_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, client)"
                                    :disabled="data.outbound_delivery_details.length > 0"
                                >
                                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col lg:w-1/5 w-full">
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Transporter ID
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.outbound_delivery.transporter_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, transporter)"
                                >
                                    <vs-select-item v-for="(item, index) in transporter.data" :key="index" :value="item.id" :text="item.transporter_code"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Service Type
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.outbound_delivery.service_type_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, service_type)"
                                >
                                    <vs-select-item v-for="(item, index) in service_type.data" :key="index" :value="item.id" :text="item.description"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Payment Type*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.outbound_delivery.payment_type_id"
                                    width="100%"
                                    autocomplete
                                >
                                    <vs-select-item v-for="(item, index) in payment_type.data" :key="index" :value="item.id" :text="item.payment_type"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Price
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.outbound_delivery.price" :disabled="data.outbound_delivery.payment_type_id == 4"/>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col lg:w-1/5 w-full">
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Business Type*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.outbound_delivery.business_type_id"
                                    width="100%"
                                    autocomplete
                                >
                                    <vs-select-item v-for="(item, index) in business_type.data" :key="index" :value="item.id" :text="item.code"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Origin*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.outbound_delivery.origin_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, customer)"
                                    @change="setCustomer('origin')"
                                >
                                    <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Address
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.outbound_delivery.origin_1" :disabled="true"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.outbound_delivery.origin_2" :disabled="true"/>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col lg:w-1/5 w-full">
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Order Type*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.outbound_delivery.order_type_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, order_type)"
                                >
                                    <vs-select-item v-for="(item, index) in order_type.data" :key="index" :value="item.id" :text="item.order_type"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Destination
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.outbound_delivery.destination_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, customer)"
                                    @change="setCustomer('destination')"
                                >
                                    <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Destination Name
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.outbound_delivery.destination_name" />
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Destination Address 1
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.outbound_delivery.destination_1" />
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Destination Address 2
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.outbound_delivery.destination_2" />
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Destination Area
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample mb-2"
                                    v-model="data.outbound_delivery.destination_area"
                                    width="100%"
                                    autocomplete
                                    @input-change="searchDropdown($event, area)"
                                >
                                <vs-select-item v-for="(item, index) in area.data" :key="index" :value="item.id" :text="item.village"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Destination Phone
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.outbound_delivery.destination_phone" />
                            </div>
                        </div>
                    </div>
                    <div class="vx-col lg:w-1/5 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Outbound Status
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.outbound_delivery.status" disabled/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Order Date
                            </div>
                            <div class="vx-col w-2/3">
                                <flat-pickr class="w-full" v-model="data.outbound_delivery.po_date" />
                            </div>
                        </div>
                    </div>
                </div>
                <vs-tabs class="mt-10">
                    <vs-tab label="Item Details" class="pt-base">
                        <vs-button @click="addItem()" class="btn mr-1" :disabled="!data.outbound_delivery.client_id" type="border">Add</vs-button>
                        <vs-button class="btn mr-1" @click="removeDetail()" :disabled="selected.length < 1" type="border">Remove</vs-button>
                        <vs-table v-model="selected" :data="data.outbound_delivery_details" hoverFlat class="mt-base" multiple>
                            <template slot="thead">
                                <vs-th style="min-width: 70px; width: 70px">Line ID</vs-th>
                                <vs-th style="min-width: 120px;">Warehouse ID</vs-th>
                                <vs-th style="min-width: 120px;">Product ID</vs-th>
                                <vs-th style="min-width: 120px;">Description</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Pack ID</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Batch</vs-th>
                                <vs-th style="min-width: 120px; width: 120px">Exp. Date</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Qty</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">UoM</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Stock Type</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Committed Qty</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Base Qty</vs-th>
                                <vs-th style="min-width: 80px; width: 80px">Base UoM</vs-th>
                            </template>
                            <template slot-scope="{data}">
                                <vs-tr :data="detail" :key="index" v-for="(detail, index) in data" >
                                    <vs-td>
                                        <vs-input class="w-full" v-model="detail.line_id" disabled/>
                                    </vs-td>
                                    <vs-td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="detail.warehouse_id"
                                            width="100%"
                                            autocomplete
                                            @input-change="searchDropdown($event, warehouse)"
                                        >
                                            <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                                        </vs-select>
                                    </vs-td>
                                    <vs-td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="detail.product_id"
                                            width="100%"
                                            autocomplete
                                            @input-change="searchProductClient($event)"
                                            @change="getProduct(detail)"
                                        >
                                            <vs-select-item v-for="(item, index) in products" :key="index" :value="item.value" :text="item.label"/>
                                        </vs-select>
                                    </vs-td>
                                    <vs-td>
                                        <vs-input class="w-full" v-model="detail.description" disabled/>
                                    </vs-td>
                                    <vs-td>
                                        <vs-input class="w-full" v-model="detail.pack_id" :disabled="detail.product_id ? false : true"/>
                                    </vs-td>
                                    <vs-td>
                                        <vs-input class="w-full" v-model="detail.batch" :disabled="detail.product_id ? false : true"/>
                                    </vs-td>
                                    <vs-td>
                                        <flat-pickr class="w-full" v-model="detail.expired_date" :disabled="detail.product_id ? false : true"/>
                                    </vs-td>

                                    <vs-td>
                                        <vs-input class="w-full" v-model="detail.qty" :danger="detail.qtyError" @input="convertQty(detail); validateQty(detail)" :disabled="detail.product_id ? false : true"/>
                                    </vs-td>
                                    <vs-td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="detail.uom_id"
                                            width="100%"
                                            autocomplete
                                            @change="uomChange(detail)"
                                            :disabled="!detail.product_id"
                                        >
                                            <vs-select-item v-for="(item, index) in detail.uoms" :key="index" :value="item.value" :text="item.label"/>
                                        </vs-select>
                                    </vs-td>
                                    <vs-td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="detail.stock_type_id"
                                            width="100%"
                                            autocomplete
                                        >
                                            <vs-select-item v-for="(item, index) in stock_type.data" :key="index" :value="item.id" :text="item.name"/>
                                        </vs-select>
                                    </vs-td>
                                    <vs-td>
                                        <vs-input class="w-full" v-model="detail.committed_qty" :disabled="true"/>
                                    </vs-td>
                                    <vs-td>
                                        <vs-input class="w-full" v-model="detail.base_qty" :disabled="true"/>
                                    </vs-td>
                                    <vs-td>
                                        <vs-select
                                            class="selectExample"
                                            v-model="detail.base_uom_id"
                                            width="100%"
                                            autocomplete
                                            disabled
                                        >
                                            <vs-select-item v-for="(item, index) in detail.uoms" :key="index" :value="item.value" :text="item.label"/>
                                        </vs-select>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </vs-tab>
                    <vs-tab label="Custom">
                        <div class="vx-row mt-6">
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        AJU Number
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.outbound_delivery_custom.aju_number" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        SPPB Number
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.outbound_delivery_custom.sppb_number" />  
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        SPPB Date
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <flat-pickr class="w-full" v-model="data.outbound_delivery_custom.sppb_date" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-5">
                                    <div class="vx-col w-1/3">
                                        BL/AWB
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.outbound_delivery_custom.blorawb" />
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Registration Number
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.outbound_delivery_custom.registration_number"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                        Registration Date
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <flat-pickr class="w-full" v-model="data.outbound_delivery_custom.registration_date" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        Invoice Number
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.outbound_delivery_custom.invoice_number" />
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/4 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                       No Kendaraan
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.outbound_delivery_custom.nokendaraan"/>
                                    </div>
                                </div>
                                 <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">
                                       Nama Supir
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.outbound_delivery_custom.namasupir"/>
                                    </div>
                                </div>
                                <div class="vx-row mb-3 mt-1">
                                    <div class="vx-col w-1/3">
                                        No Hp
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.outbound_delivery_custom.nohp" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="Notes">
                        <vs-textarea height="200" class="mt-5" label="Notes" v-model="data.outbound_delivery.remark"/>
                    </vs-tab>
                </vs-tabs>
            </vs-card>
        </div>
    </div>
</template>

<script>
	import vSelect from 'vue-select'
	import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import { AgGridVue } from "ag-grid-vue";

	export default {
		components:{
            AgGridVue,
			vSelect,
			flatPickr,
		},
		data(){
			return {
                area: {
                    data: [],
                    loading: false,
                    endpoint: 'master/areas',
                    objectKey: 'village'
                },
                selected: [],
                business_types: [],
                products: [],
                isLoading: false,
                oldData: {},
                data: {
                    outbound_delivery: {
                        outbound_reference: '',
                        req_del_date: null,
                        order_type_id: null,
                        origin_id: null,
                        client_id: null,
                        po_reference: '',
                        po_date: null,
                        destination_id: null,
                        origin_1: null,
                        origin_2: null,
                        destination_name: null,
                        destination_1: null,
                        destination_2: null,
                        destination_area: null,
                        destination_district: null,
                        destination_postcode: null,
                        destination_phone: null,
                        status: 'Uncommitted',
                        remark: '',
                        business_type_id: 1,
                        service_type_id: null,
                        transporter_id: null,
                        payment_type_id: 4,
                        price: '',
                        awb: ''
                    },
                    outbound_delivery_custom: {
                        aju_number: '',
                        sppb_number: '',
                        sppb_date: null,
                        blorawb: '',
                        registration_number: '',
                        registration_date: null,
                        invoice_number: '',
                        nokendaraan: '',
                        namasupir: '',
                        nohp: '',
                    },
                    outbound_delivery_details: []
                },
                client: {
                    data: [],
                    loading: false,
                    endpoint: 'master/clients',
                    objectKey: 'client_code'
                },
                business_type: {
                    data: []
                },
                order_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/ordertypes',
                    objectKey: 'order_type'
                },
                transporter: {
                    data: [],
                    loading: false,
                    endpoint: 'master/transporters',
                    objectKey: 'transporter_code'
                },
                service_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/servicetypes',
                    objectKey: 'service_type'
                },
                customer: {
                    data: [],
                    loading: false,
                    endpoint: 'master/customers',
                    objectKey: 'name'
                },
                stock_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/stocktypes',
                    objectKey: 'name'
                },
                warehouse: {
                    data: [],
                    loading: false,
                    endpoint: 'master/warehouses',
                    objectKey: 'warehouses_code'
                },
                payment_type: {
                    data: []
                }
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            },
        },
        methods:{
            submitForm() {
                const warehouseIds = [...new Set(this.data.outbound_delivery_details.map(item => item.warehouse_id))]

                if(warehouseIds.length != 1) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error saving',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Error saving, different warehouses'
                    })
                    return false
                }

                for(let detail of this.data.outbound_delivery_details){
                    if(!detail.warehouse_id || !detail.product_id || !detail.qty || detail.qty <= 0 || !detail.uom_id || !detail.stock_type_id) {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error saving',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: 'Error saving, check line ' + detail.line_id
                        })
                        return false
                    }

                    if(detail.pack_id && detail.qty > 1) {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error saving',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: 'Line ' + detail.line_id + ' - Pack ID qty must be 1.'
                        })
                        return false
                    }
                }

                if(this.data.outbound_delivery.business_type_id == 1 && !this.data.outbound_delivery.transporter_id) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'B2C requires transporter ID.'
                    })
                    return false
                }

                this.isLoading = true
                this.data.outbound_delivery_details = this.combineLine()

                this.$http.post('outbound/outbounddelivery/store', this.data)
                .then(res => {
                    this.isLoading = false
                    this.$vs.notify({
                        color: 'success',
                        title: 'Saved successfully',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Outbound added'
                    })
                    this.$router.push({ name: 'outbound-view', params: {id: res.data.id} })
                })
                .catch(error => this.handleError(error))
            },
            back() {
                if(JSON.stringify(this.oldData) == JSON.stringify(this.data)) {
                    this.$router.push({name: 'outbound-delivery'})
                }
                else {
                    this.$vs.dialog({
                        color: 'warning',
                        title: 'Leave Page',
                        text: 'Changes you made may not be saved',
                        acceptText: 'Leave Page',
                        accept: () => this.$router.push({name: 'outbound-delivery'}),
                    })
                }
            },
            removeDetail(){
                let indexes = []
                this.selected.map(selected => {
                    this.data.outbound_delivery_details.map((detail, index) => {
                        if(selected.line_id == detail.line_id) {
                            indexes.push(index)
                        }
                    })
                })

                indexes.sort((a, b) => b - a)
                indexes.map(i => this.data.outbound_delivery_details.splice(i, 1))
                this.selected = []
                this.assignLineId()
            },
            addItem() {
                if(this.data.outbound_delivery_details.length < 1) {
                    this.isLoading = true
                    this.$http.post('master/product/showbyclient', { client_id: this.data.outbound_delivery.client_id })
                    .then(res => {
                        this.products = []
                        this.isLoading = false

                        res.data.data.map(item => {
                            const uoms = item.uoms.map(uom => {
                                return {
                                    value: uom.uom_id,
                                    label: uom.uom.name,
                                    numerator: uom.numerator,
                                    denominator: uom.denominator,
                                }
                            })
                            this.products.push({ value: item.id, label: item.product_code, description_1: item.description_1, description_2: item.description_2, base_uom: item.base_uom, uoms: uoms })
                        })

                        this.data.outbound_delivery_details.push({
                            line_id: 0,
                            warehouse_id: this.$store.state.user.userconfig.warehouses.id ? this.$store.state.user.userconfig.warehouses.id : null,
                            product_id: null,
                            description: '',
                            pack_id: '',
                            batch: '',
                            expired_date: null,
                            qty: '',
                            uom_id: null,
                            stock_type_id: this.$store.state.user.userconfig.stock_type.id ? this.$store.state.user.userconfig.stock_type.id : null,
                            committed_qty: 0,
                            base_qty: '',
                            base_uom_id: null,
                            uoms: [],
                            qtyError: false,
                            denominator: 0,
                            numerator: 0,
                        })
                        
                        this.assignLineId()
                    })
                    .catch(error => this.handleError(error))
                }
                else {
                    this.data.outbound_delivery_details.push({
                        line_id: 0,
                        warehouse_id: this.$store.state.user.userconfig.warehouses.id ? this.$store.state.user.userconfig.warehouses.id : null,
                        product_id: null,
                        description: '',
                        pack_id: '',
                        batch: '',
                        expired_date: null,
                        qty: '',
                        uom_id: null,
                        stock_type_id: this.$store.state.user.userconfig.stock_type.id ? this.$store.state.user.userconfig.stock_type.id : null,
                        committed_qty: 0,
                        base_qty: '',
                        base_uom_id: null,
                        uoms: [],
                        qtyError: false,
                        denominator: 0,
                        numerator: 0,
                    })
                    
                    this.assignLineId()
                }
            },
            getProduct(detail) {
                const data = this.products[this.products.findIndex(a => a.value === detail.product_id)]
                detail.description = data.description_1
                detail.uom_id = data.base_uom.uom_id
                detail.base_uom_id = data.base_uom.uom_id
                detail.uoms = data.uoms

                const uom = detail.uoms[detail.uoms.findIndex(a => a.value === detail.uom_id)]
                detail.numerator = uom.numerator
                detail.denominator = uom.denominator

                detail.base_qty = 1
                detail.qty = 1
            },
            uomChange(detail) {
                const data = detail.uoms[detail.uoms.findIndex(a => a.value === detail.uom_id)]
                detail.numerator = data.numerator
                detail.denominator = data.denominator

                this.convertQty(detail)
            },
            convertQty(detail){
                detail.base_qty = (detail.qty / detail.denominator) * detail.numerator
            },
            validateQty(detail) {
                if(detail.qty <= 0) {
                    detail.qtyError = true
                }
                else {
                    detail.qtyError = false
                }
            },
            setDestination() {
                this.data.outbound_delivery.destination_1 = this.data.outbound_delivery.destination.address_1
                this.data.outbound_delivery.destination_2 = this.data.outbound_delivery.destination.address_2
            },
            setCustomer(val) {
                if(val == 'origin') {
                    const index = this.customer.data.findIndex(c => c.id == this.data.outbound_delivery.origin_id)
                    this.data.outbound_delivery.origin_1 = this.customer.data[index].address_1
                    this.data.outbound_delivery.origin_2 = this.customer.data[index].address_2
                }
                else if(val == 'destination') {
                    const index = this.customer.data.findIndex(c => c.id == this.data.outbound_delivery.destination_id)
                    this.data.outbound_delivery.destination_1 = this.customer.data[index].address_1
                    this.data.outbound_delivery.destination_2 = this.customer.data[index].address_2
                }
            },
            clientChange() {
                this.productOptions = []
                if(this.data.outbound_delivery_details.length > 0) {
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'danger',
                        title: 'Confirmation',
                        text: 'Changing client will remove details, continue?',
                        accept: () => {
                            this.data.outbound_delivery_details = []
                        },
                        acceptText: 'Yes',
                        cancelText: 'No'
                    });
                }
            },
            assignLineId() {
                this.data.outbound_delivery_details.map((detail, index) => {
                    detail.line_id = index + 1
                })
            },
            combineLine() {
                const details = []
                let found = false

                this.data.outbound_delivery_details.map(item => {
                    if(details.length >= 1) {
                        for(let i = 0; i < details.length; i++) {
                            if(details[i].product_id == item.product_id && details[i].stock_type_id == item.stock_type_id && details[i].uom_id == item.uom_id && details[i].pack_id == item.pack_id && details[i].expired_date == item.expired_date && details[i].batch == item.batch) {
                                details[i].qty = parseInt(details[i].qty) + parseInt(item.qty)
                                found = true

                                break
                            }
                            
                        }
                        
                        if(!found) {
                            details.push(item)
                        }
                    }
                    else {
                        details.push(item)
                    }
                })

                return details
            },
            fetchData() {
                this.isLoading = true
                Promise.all([
                    this.$http.post('master/warehouses'),
                    this.$http.post('master/clients'),
                    this.$http.post('master/businesstypes'),
                    this.$http.post('master/ordertypes'),
                    this.$http.post('master/transporters'),
                    this.$http.post('master/servicetypes'),
                    this.$http.post('master/customers'),
                    this.$http.post('master/stocktypes'),
                    this.$http.get('master/paymenttypes'),
                ])
                .then(this.$http.spread((warehouses, clients, businesstypes, ordertypes, transporters, servicetypes, customers, stocktypes, paymenttypes) => {
                    this.warehouse.data = warehouses.data.data
                    this.client.data = clients.data.data
                    this.business_type.data = businesstypes.data.data
                    this.order_type.data = ordertypes.data.data
                    this.transporter.data = transporters.data.data
                    this.service_type.data = servicetypes.data.data
                    this.customer.data = customers.data.data
                    this.stock_type.data = stocktypes.data.data
                    this.payment_type.data = paymenttypes.data
                    this.isLoading = false
                }))
                .catch(error => this.handleError(error))
            },
            searchProductClient(e) {
                this.$http.post('master/product/showbyclient', { client_id: this.data.outbound_delivery.client_id, product_code: e.target.value })
                .then(res => {
                    res.data.data.map(item => {
                        const uoms = item.uoms.map(uom => {
                            return {
                                value: uom.uom_id,
                                label: uom.uom.name,
                                numerator: uom.numerator,
                                denominator: uom.denominator,
                            }
                        })

                        if(this.products.findIndex(p => p.value === item.id) === -1) {
                            this.products.push({ value: item.id, label: item.product_code, description_1: item.description_1, description_2: item.description_2, base_uom: item.base_uom, uoms: uoms })
                        }
                    })
                })
            }
        },
        mounted(){
            this.fetchData()
            this.oldData = JSON.parse(JSON.stringify(this.data))
        },
	}
</script>